import { Vector3 } from "three";
import { VOMarker } from "../model/DataStructure.js";
import { MarkerUpdateInfo } from "./MarkerLayer.js";

export interface MarkerOptions {
    marker: VOMarker;
}

export class Marker {

    public readonly onClick = e5.Signal.create<[Marker]>();

    private readonly _element: HTMLAnchorElement;

    public readonly position: Vector3;

    public x: number = 0;
    public y: number = 0;
    public cameraDistance: number = 0;

    public readonly marker: VOMarker;

    public zIndexOffset: number = 0;

    private _lastX: number = 0;
    private _lastY: number = 0;

    constructor(container: HTMLElement, options: MarkerOptions) {
        // options = e5.object.merge({}, options);

        this.marker = options.marker;

        this._element = document.createElement("a");
        this._element.href = "#";
        this._element.setAttribute("aria-label", (options.marker.index + 1) + " " + this.marker.name);
        this._element.className = "awi-marker";
        this._element.innerHTML = `
        <div class="awi-marker__label">${(options.marker.index + 1) + ""}</div>
        <div class="awi-marker__close fal fa-times"></div>
        `;
        container.appendChild(this._element);

        // this.position = new Vector3(options.x, options.y, options.z);
        this.position = new Vector3(options.marker.target_x, options.marker.target_y, options.marker.target_z);

        this._element.addEventListener("click", () => {
            this.onClick.dispatch(this);
        });
    }

    public update(info: MarkerUpdateInfo): void {

        if (this._lastX == info.x
            && this._lastY == info.y) {
            return;
        }

        this._lastX = info.x;
        this._lastY = info.y;
        this._element.style.zIndex = info.zIndex + "";
        this._element.style.transform = `translate3d(${info.x}px, ${info.y}px, 0)`;
        // this._content.style.transform = `translate3d(${info.x}px, ${info.y}px, 0) translateY(-50%)`;

        // this._content.style.left = Math.round(info.x) + "px";
        // this._content.style.top = Math.round(info.y) + "px";
    }

    public get selected(): boolean {
        return this._element.classList.contains("awi-marker--selected");
    }

    public set selected(value: boolean) {
        this._element.classList.toggle("awi-marker--selected", value);
    }
}